import { Link } from 'react-router-dom';
import { Menu } from 'antd';

export type SideMenuProps = {
  defaultSelectedKeys?: string[];
  mode?: 'inline' | 'horizontal' | 'vertical' | 'vertical-left' | 'vertical-right';
  inlineIndent?: number;
};

const SideMenu = ({ defaultSelectedKeys, mode, inlineIndent }: SideMenuProps) => {
  // 노출메뉴 선택 토글 (2차 고도화시 추가)
  // const [ menu, setMenu ] = useState("스마트핀카");
  /* const toggleMenu = (
      <Menu>
          <Menu.Item key="1" onClick={() => setMenu("스마트핀카")}>스마트 핀카</Menu.Item>
          <Menu.Item key="2" onClick={() => setMenu("스마트민원")}>스마트 민원</Menu.Item>
      </Menu>
  ); */

  // 스마트 핀카 메뉴 (2차 고도화시 추가)
  /* const smartPincar = (
      <Menu defaultSelectedKeys={defaultSelectedKeys} defaultOpenKeys={defaultOpenKeys} mode={mode}>
          <Menu.ItemGroup title="자산관리">
              <Menu.Item key="1"><span>차량목록<i></i></span></Menu.Item>
          </Menu.ItemGroup>
          <Menu.ItemGroup title="스마트 알림">
              <Menu.Item key="3"><span>차량 알림<i></i></span></Menu.Item>
              <Menu.Item key="4"><span>시세 알림<i></i></span></Menu.Item>
              <Menu.Item key="5"><span>혜택 알림<i></i></span></Menu.Item>
              <Menu.Item key="6"><span>견적 알림<i></i></span></Menu.Item>
          </Menu.ItemGroup>
       </Menu>
  ); */

  // 스마트 민원 메뉴
  const smartMinwon = (
    <Menu defaultSelectedKeys={defaultSelectedKeys} mode={mode} inlineIndent={inlineIndent}>
      <Menu.ItemGroup title="업무 관리" className="icon-task">
        <Menu.Item key="1">
          <span>
            고지서 관리
            <i />
          </span>
          <Link to="/" />
        </Menu.Item>
        <Menu.Item key="2">
          <span>
            민원 관리
            <i />
          </span>
          <Link to="/MaganeMinwon" />
        </Menu.Item>
      </Menu.ItemGroup>
      <Menu.ItemGroup title="서비스 정보" className="icon-service">
        <Menu.Item key="3">
          <span>
            민원 신청 양식
            <i />
          </span>
          <Link to="/OcrRegist" />
        </Menu.Item>
        <Menu.Item key="4">
          <span>
            핀카 API키
            <i />
          </span>
          <Link to="/OcrDocument" />
        </Menu.Item>
        <Menu.Item key="5">
          <span>
            연동 계정 관리
            <i />
          </span>
          <Link to="/OcrFax" />
        </Menu.Item>
        <Menu.Item key="6">
          <span>
            사용내역
            <i />
          </span>
        </Menu.Item>
      </Menu.ItemGroup>
    </Menu>
  );

  return (
    <div className="side-wrap">
      <h2 className="service-title">스마트 민원</h2>
      {/* 2차 고도화시 메뉴 선택 옵션 추가 부분 */}
      {/* <Dropdown overlay={toggleMenu} trigger={['click']}>
                <h1 className="ant-dropdown-link">핀카비즈센터</h1>
            </Dropdown> */}
      <div>
        {/* { menu === "스마트핀카" ? smartPincar : smartMinwon } */}
        {smartMinwon}
      </div>
    </div>
  );
};

SideMenu.defaultProps = {
  defaultSelectedKeys: ['1'],
  mode: 'inline',
  inlineIndent: 0,
};

export default SideMenu;
